export const RightAngleIcon: React.VFC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox='0 0 8 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 6.5L1.45455 13L0 11.5556L5.09091 6.5L0 1.44444L1.45455 0L8 6.5Z'
      fill='currentColor'
    />
  </svg>
);
